let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("izNV7")).then(() => parcelRequire('b2cpi'));